import { Modal } from "antd";
import React from "react";
import Icon from "../../assets/Icon";

function PreviewRejoinModal({ previewRejoinModal, interviewId }) {
  const handleRejoin = () => {
    window.location.href = `/preview?interviewId=${interviewId}`;
  };
  return (
    <>
      <Modal
        className="rejoin-modal"
        open={previewRejoinModal}
        centered
        onCancel={handleRejoin}
        footer={[
          <div className="flex justify-end">
            <button className="btn-blue px-3 py-2" onClick={handleRejoin}>
              Rejoin Interview
            </button>
          </div>,
        ]}
        width={465}
      >
        <div className="">
          <Icon type="warning-icon" width="45" height="45" />
        </div>
        <div className="mt-[.55rem] font-semibold text-[1.05rem] text-[#101828]">
          Device Change Detected
        </div>
        <p className="mt-[.55rem] text-[0.9rem] text-[#475467] leading-[1.38rem]">
          This is a proctored environment. To ensure integrity, you will be
          redirected to rejoin the preview screen.
        </p>
      </Modal>
    </>
  );
}

export default PreviewRejoinModal;
